import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { CmsCollection, CmsContent, CmsTarget } from '@fcom/core-api';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

/**
 * Maps links with url in root object to use 'target' object instead
 * @param items
 * @returns copy of items with url within 'target'
 */
const mapUrlToTarget = (items: CmsTarget[] | CmsContent[]) => {
  const formattedItems: CmsContent[] = [];
  items?.forEach((item) => {
    if (item.target?.url) {
      formattedItems.push(item);
    } else if (item.url) {
      const formattedItem = { ...item };
      formattedItem.target = {
        url: item.url,
        external: item.external,
      };
      formattedItems.push(formattedItem);
    }
  });
  return formattedItems;
};

@Component({
  selector: 'cms-link-list-with-icons',
  templateUrl: './cms-link-list-with-icons.component.html',
  styleUrls: ['./cms-link-list-with-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsLinkListWithIconsComponent {
  private themeService = inject(FinnairThemeService);

  readonly SvgLibraryIcon = SvgLibraryIcon;

  content = input<CmsCollection>();

  readonly isNewBrand = computed<boolean>(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);

  readonly items = computed<CmsContent[] | undefined>(() => {
    const items = this.content()?.items;
    return items?.length ? mapUrlToTarget(items) : undefined;
  });
}
